export default "/images/vendor/@coreui/icons/svg/flag/cif-tr.svg?8693d95af16b4e8a669216bc7f3273b6";